const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  temps: state => state.user.temps,
  orderId: state => state.user.orderId,
  roleId: state => state.user.roleId,
  userId: state => state.user.userId,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js